import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "@project/user/pages/auth/LoginPage";

export const Route = createFileRoute("/_user/login")({
  head: () => ({
    meta: [
      { title: "Sign In — Jivandhara" },
      {
        name: "description",
        content: "Sign in to your Jivandhara account using phone OTP.",
      },
    ],
  }),
  component: LoginPage,
});
